import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';

/**
 * Initializes safe area insets for native platforms
 * Sets CSS custom properties for safe area values
 */
export function initializeSafeArea() {
  if (Capacitor.isNativePlatform()) {
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      for (const [key, value] of Object.entries(insets)) {
        document.documentElement.style.setProperty(
          `--safe-area-inset-${key}`,
          `${value}px`
        );
      }
    });
  }
}